import AgentHubEarnYourOwnTourBanner from 'agentHub/components/AgentHubEarnYourOwnTourBanner'
import {
  markAgentHubEarnYourOwnTourModalDismissed,
} from 'agentHub/storage/agentHubEarnYourOwnTourModalStorage'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import Modal from 'LuxKit/Modal/Modal'
import type { MouseEventHandler } from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  margin: 0 auto;
  padding: 0;

  .flush-vertical-top {
    padding-top: 0;
    padding-bottom: 0;
    background: red;
  }
`

function AgentHubEarnYourOwnTourModal() {
  const modalContext = useModalElementContext()

  const handleClose = useCallback<MouseEventHandler<HTMLElement>>(() => {
    markAgentHubEarnYourOwnTourModalDismissed()
    modalContext.resolve()
  }, [modalContext])

  const handleFindOutMoreClick = useCallback(() => {
    markAgentHubEarnYourOwnTourModalDismissed()
    modalContext.resolve()
  }, [modalContext])

  return (
    <StyledModal
      flush
      flushVerticalTop
      flushListItems
      isHeaderOverlay
      isSecondaryActionHidden
      isPrimaryActionHidden
      size="L"
      title=""
      onClose={handleClose}
    >
      <AgentHubEarnYourOwnTourBanner
        size="medium"
        variant="modal"
        onFindOutMoreClick={handleFindOutMoreClick}
      />
    </StyledModal>
  )
}

export default AgentHubEarnYourOwnTourModal
